"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IModelsApiUrlFormatter = void 0;
class IModelsApiUrlFormatter {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this._regexIgnoreCaseOption = "i";
        this._groupNames = {
            iModelId: "iModelId",
            changesetIndex: "changesetIndex",
            namedVersionId: "namedVersionId"
        };
        this._checkpointUrlRegex = new RegExp(`/iModels/(?<${this._groupNames.iModelId}>.*?)/changesets/(?<${this._groupNames.changesetIndex}>.*?)/checkpoint`, this._regexIgnoreCaseOption);
        this._namedVersionUrlRegex = new RegExp(`/iModels/(?<${this._groupNames.iModelId}>.*?)/namedversions/(?<${this._groupNames.namedVersionId}>.*)`, this._regexIgnoreCaseOption);
    }
    getCreateIModelUrl() {
        return this.baseUrl;
    }
    getSingleIModelUrl(params) {
        return `${this.baseUrl}/${params.iModelId}`;
    }
    getIModelListUrl(params) {
        return `${this.baseUrl}${this.formQueryString({ ...params.urlParams })}`;
    }
    getSingleBriefcaseUrl(params) {
        return `${this.baseUrl}/${params.iModelId}/briefcases/${params.briefcaseId}`;
    }
    getBriefcaseListUrl(params) {
        return `${this.baseUrl}/${params.iModelId}/briefcases${this.formQueryString({ ...params.urlParams })}`;
    }
    getSingleChangesetUrl(params) {
        var _a;
        return `${this.baseUrl}/${params.iModelId}/changesets/${(_a = params.changesetId) !== null && _a !== void 0 ? _a : params.changesetIndex}`;
    }
    getChangesetListUrl(params) {
        return `${this.baseUrl}/${params.iModelId}/changesets${this.formQueryString({ ...params.urlParams })}`;
    }
    getSingleNamedVersionUrl(params) {
        return `${this.baseUrl}/${params.iModelId}/namedversions/${params.namedVersionId}`;
    }
    getNamedVersionListUrl(params) {
        return `${this.baseUrl}/${params.iModelId}/namedversions${this.formQueryString({ ...params.urlParams })}`;
    }
    getCheckpointUrl(params) {
        var _a;
        const parentEntityUrlPath = params.namedVersionId
            ? `namedversions/${params.namedVersionId}`
            : `changesets/${(_a = params.changesetId) !== null && _a !== void 0 ? _a : params.changesetIndex}`;
        return `${this.baseUrl}/${params.iModelId}/${parentEntityUrlPath}/checkpoint`;
    }
    parseCheckpointUrl(url) {
        const matchedGroups = this._checkpointUrlRegex.exec(url).groups;
        return {
            iModelId: matchedGroups[this._groupNames.iModelId],
            changesetIndex: parseInt(matchedGroups[this._groupNames.changesetIndex], 10)
        };
    }
    parseNamedVersionUrl(url) {
        const matchedGroups = this._namedVersionUrlRegex.exec(url).groups;
        return {
            iModelId: matchedGroups[this._groupNames.iModelId],
            namedVersionId: matchedGroups[this._groupNames.namedVersionId]
        };
    }
    formQueryString(urlParameters) {
        let queryString = "";
        for (const urlParameterKey in urlParameters) {
            if (!Object.prototype.hasOwnProperty.call(urlParameters, urlParameterKey))
                continue;
            const urlParameterValue = urlParameters[urlParameterKey];
            if (!this.shouldAppendToUrl(urlParameterValue))
                continue;
            queryString = this.appendToQueryString(queryString, urlParameterKey, urlParameterValue);
        }
        return queryString;
    }
    shouldAppendToUrl(urlParameterValue) {
        if (urlParameterValue === null || urlParameterValue === undefined)
            return false;
        if (typeof urlParameterValue === "string" && !urlParameterValue.trim())
            return false;
        return true;
    }
    appendToQueryString(existingQueryString, parameterKey, parameterValue) {
        const separator = existingQueryString.length === 0 ? "?" : "&";
        return `${existingQueryString}${separator}${parameterKey}=${this.stringify(parameterValue)}`;
    }
    stringify(urlParameterValue) {
        if (this.isOrderBy(urlParameterValue)) {
            let result = urlParameterValue.property;
            if (urlParameterValue.operator)
                result += ` ${urlParameterValue.operator}`;
            return result;
        }
        return urlParameterValue.toString();
    }
    isOrderBy(parameterValue) {
        return parameterValue.property !== undefined;
    }
}
exports.IModelsApiUrlFormatter = IModelsApiUrlFormatter;
//# sourceMappingURL=IModelsApiUrlFormatter.js.map